import { useGetBoardForms } from 'api/forms';
import {
  Breadcrumbs,
  DataWrapper,
  MetaTitle,
  PaginationReactRouter,
} from 'components/shared';

import { useTranslation } from 'react-i18next';
import { useFormsListContext } from './context';
import { useFormsListSearchParams } from './hooks';
import { Header } from './Header';
import { FormsTable } from './FormsTable';
import { FormsMassActions } from './FormsMassActions';
import { NotFound } from './NotFound';
import { NewFormWizard } from './NewFormWizard';

export const FormsListView = () => {
  const { t } = useTranslation();
  const { params } = useFormsListSearchParams();
  const { newFormWizardOpen, setNewFormWizardOpen } = useFormsListContext();
  const { data: formsData, isError, isLoading } = useGetBoardForms(params);

  return (
    <>
      <MetaTitle value={t('navigation:navbar.forms')} />
      <Breadcrumbs items={[{ name: t('navigation:navbar.forms'), url: '#' }]} />
      <Header />
      <DataWrapper
        data={formsData}
        isError={isError}
        isLoading={isLoading}
        errorMargin="xl"
      >
        {({ data, meta }) => (
          <>
            <FormsTable forms={data} />
            {data.length === 0 && <NotFound />}
            <PaginationReactRouter meta={meta} isStickyToBottom />
          </>
        )}
      </DataWrapper>
      <FormsMassActions />
      <NewFormWizard
        opened={newFormWizardOpen}
        onClose={() => setNewFormWizardOpen(false)}
      />
    </>
  );
};
